import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f37d0c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "hisBind"
};
const _hoisted_2 = {
  class: "flex align-end"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header",
  style: {
    "margin-right": "200px"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "绑定微信")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "绑定新微信, 扫描一下二维码, 自动绑定", -1));
const _hoisted_5 = {
  class: "flex"
};
import { getWebQrCode, getWebScanUser } from '@/api/sys';
import { onMounted, onUnmounted, ref } from 'vue';
import QRcode from 'qrcode';
import { ElMessage } from 'element-plus';
export default {
  __name: 'index',
  setup(__props) {
    const form = ref({
      userName: '',
      name: '',
      openid: '',
      userBindTime: ''
    });
    const codeRef = ref(null);
    const _getWebQrCode = async () => {
      const res = await getWebQrCode();
      QRcode.toCanvas(codeRef.value, res.url, {
        width: 380 // 自定义宽度
      });
    };
    const _getWebScanUser = async () => {
      var _form$value, _form$value2, _form$value3, _form$value4;
      const res = await getWebScanUser();
      if (res && (((_form$value = form.value) === null || _form$value === void 0 ? void 0 : _form$value.name) !== (res === null || res === void 0 ? void 0 : res.name) || ((_form$value2 = form.value) === null || _form$value2 === void 0 ? void 0 : _form$value2.userName) !== (res === null || res === void 0 ? void 0 : res.userName) || ((_form$value3 = form.value) === null || _form$value3 === void 0 ? void 0 : _form$value3.openid) !== (res === null || res === void 0 ? void 0 : res.openid) || ((_form$value4 = form.value) === null || _form$value4 === void 0 ? void 0 : _form$value4.userBindTime) !== (res === null || res === void 0 ? void 0 : res.userBindTime))) {
        form.value = res;
      }
    };
    onMounted(() => {
      _getWebQrCode();
      _getWebScanUser();
    });
    onUnmounted(() => {});
    const handleGetUser = async () => {
      await _getWebScanUser();
      ElMessage.success('获取信息成功');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        },
        class: "card-content"
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_button, {
          size: "small",
          type: "success",
          onClick: handleGetUser
        }, {
          default: _withCtx(() => [_createTextVNode("刷新绑定用户信息")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          size: "large",
          "label-width": "150px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "当前账户",
            style: {
              "max-width": "800px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.userName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "border-style": "solid",
            style: {
              "margin": "15px 0"
            }
          }), _createVNode(_component_el_form_item, {
            label: "当前姓名",
            style: {
              "max-width": "800px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "border-style": "solid",
            style: {
              "margin": "15px 0"
            }
          }), _createVNode(_component_el_form_item, {
            label: "当前微信",
            style: {
              "max-width": "800px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.openid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.openid = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "border-style": "solid",
            style: {
              "margin": "15px 0"
            }
          }), _createVNode(_component_el_form_item, {
            label: "绑定时间",
            style: {
              "max-width": "800px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.userBindTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.userBindTime = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_divider, {
          "border-style": "solid",
          style: {
            "margin": "25px 0 12px"
          }
        }), _hoisted_4, _createVNode(_component_el_divider, {
          "border-style": "solid",
          style: {
            "margin-top": "10px"
          }
        }), _createElementVNode("div", _hoisted_5, [_createElementVNode("canvas", {
          ref_key: "codeRef",
          ref: codeRef
        }, null, 512)]), _createVNode(_component_el_button, {
          style: {
            "margin-left": "50px"
          },
          type: "primary",
          onClick: _getWebQrCode
        }, {
          default: _withCtx(() => [_createTextVNode("重新获取二维码")]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};